import React, { useEffect, useState } from 'react';
import { Popover } from '../popover/popover';
import { CopyButton } from '../copy-button/copy-button';
import Text from '../text/text';
import { MeetingApiParams } from '../../_events/_manage-event/shared/connections-list/_connection-form/connection-form.viewmodel';

interface IPodiumLinkPopoverProps {
    isOpen: boolean;
    buttonRef: React.MutableRefObject<HTMLDivElement>;
    getPodiumLink: (params: MeetingApiParams) => Promise<string>;
    handlePodiumLinkFailure: (e: Error) => void;
    onClose: () => void;
    onCopy: () => void;
}

const PodiumLinkPopover = ({
    buttonRef,
    isOpen,
    getPodiumLink,
    onClose,
    handlePodiumLinkFailure,
    onCopy,
}: IPodiumLinkPopoverProps) => {
    const [podiumLink, setPodiumLink] = useState('');

    useEffect(() => {
        if (!isOpen) {
            setPodiumLink('');
            return;
        }

        const fetchPodiumLink = async () => {
            try {
                const link = await getPodiumLink(null);
                if (link) setPodiumLink(link);
            } catch (error) {
                handlePodiumLinkFailure(error);
                onClose();
            }
        };
        fetchPodiumLink();
    }, [isOpen]);

    return (
        <div className='connection-item-popover'>
            <Popover
                isOpen={isOpen && !!podiumLink}
                buttonRef={buttonRef}
                onClickOutside={onClose}
                onClose={onClose}
                position='bottom'
                align='start'
                padding={0}
                customWidth={225}
            >
                    <div className='w-100'>
                        <div className='connection-list__popover'>
                            <Text message='Podium Link' tag='h4' className='m-0px connection-item-popover__podium-title' />
                            <div className='flex center'>
                                <Text message={podiumLink} withEllipsis className='connection-item-popover__podium-text' />
                                <CopyButton onCopy={onCopy} withoutIcon copyValue={podiumLink} className='m-left-5px' />
                            </div>
                        </div>
                    </div>
            </Popover>
        </div>
    );
};

export {
    PodiumLinkPopover
};
